// config.js
const getRuntimeConfig = () => {
    // Check if window._env_ exists (will be injected at runtime)
    return {
        apiUrl: window._env_?.REACT_APP_APIURL || "https://demoapi.invgap.org"
    };
};

export const config = getRuntimeConfig();
export default config.apiUrl;
  